// FormFrame/fields/fieldUtils.ts
import type { FieldDef } from "./fieldTypes"
import type * as React from "react"

export function getErrorText(err: unknown): string {
    if (!err) return ""
    if (typeof err === "string") return err
    if (typeof err === "object" && err && "message" in err) {
        const m = (err as { message?: unknown }).message
        if (typeof m === "string") return m
    }
    return ""
}

export function getHelpText(def: FieldDef): string {
    const v = (def as any)?.messages?.help
    if (!v) return ""
    return String(v)
}

export function getRequiredMark(def: FieldDef): string {
    return (def as any).required ? " *" : ""
}

export function toggleValue(arr: string[], v: string): string[] {
    if (arr.includes(v)) return arr.filter((x) => x !== v)
    return [...arr, v]
}

export function normalizeString(v: unknown): string {
    if (v === null || v === undefined) return ""
    return String(v)
}

export function normalizeStringArray(v: unknown): string[] {
    if (!Array.isArray(v)) return []
    return v.map((x) => String(x))
}

export function normalizeInlineLabel(v: React.ReactNode): React.ReactNode {
    if (typeof v === "string") return v.replace(/\s*,\s*$/, "")
    return v
}
